import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { MAX_DESKTOP_BREAKPOINT, MIN_DESKTOP_BREAKPOINT } from '../components/general/constants/_breakpoints';
import { HEADER_HEIGHT } from '../components/general/constants/_sizes';

const Row = styled.div`
  display: flex;

  @media only screen and (max-width: ${MAX_DESKTOP_BREAKPOINT}) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    flex: 50%;
    height: ${({ columnHeight }) => columnHeight};
    overflow-y: auto;
    flex-basis: ${({ twoThirdsSplit }) => (twoThirdsSplit ? '33%' : 'none')};
  }
`;

const WebOnlyColumn = styled(Column)`
  @media only screen and (max-width: ${MAX_DESKTOP_BREAKPOINT}) {
    display: none;
  }
`;

const TwoColumnLayout = ({ columnOneContent, columnTwoContent, hideFirstColumnMobile, height, twoThirdsSplit }) => (
  <Row>
    {hideFirstColumnMobile && <WebOnlyColumn columnHeight={height}>{columnOneContent}</WebOnlyColumn>}
    {!hideFirstColumnMobile && <Column columnHeight={height}>{columnOneContent}</Column>}
    <Column columnHeight={height} twoThirdsSplit={twoThirdsSplit}>
      {columnTwoContent}
    </Column>
  </Row>
);

TwoColumnLayout.propTypes = {
  columnOneContent: PropTypes.node.isRequired,
  columnTwoContent: PropTypes.node.isRequired,
  hideFirstColumnMobile: PropTypes.bool,
  height: PropTypes.string,
};

TwoColumnLayout.defaultProps = {
  hideFirstColumnMobile: false,
  height: `calc(100vh - ${HEADER_HEIGHT})`,
};

export default TwoColumnLayout;
